<template>
  <div class="washrooms-count" :class="{'washrooms-count--large': large && large == true}">
    <div class="washroom-icon">
      <img src="/static/img/washroom--male.svg">
      <div class="washroom-badge font-primary--bold">
        <span>{{countWashrooms('Male')}}</span>
      </div>
    </div>

    <div class="washroom-icon">
      <img src="/static/img/washroom--female.svg">
      <div class="washroom-badge font-primary--bold">
        <span>{{countWashrooms('Female')}}</span>
      </div>
    </div>

    <div class="washroom-icon">
      <img src="/static/img/washroom--disabled.svg">
      <div class="washroom-badge font-primary--bold">
        <span>{{countWashrooms('Disabled')}}</span>
      </div>
    </div>

    <div class="washroom-icon">
      <img src="/static/img/washroom--baby-changing.svg">
      <div class="washroom-badge font-primary--bold">
        <span>{{countWashrooms('BabyChanging')}}</span>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'washrooms-count',

    props: [
      'washrooms',
      'large'
    ],

    data: function () {
      return {

      }
    },

    mounted:function() {

    },

    beforeDestroy: function() {

    },

    methods: {
      countWashrooms: function(facilityType) {
        let washroomsFiltered = this.washrooms.filter((item) => item.facilityType == facilityType);
        return washroomsFiltered.length;
      }
    },

    computed:{

    }
  }
</script>

<style lang="less" scoped>
  @import "../../../less/base/project/_colors";

  .washrooms-count {
    white-space: nowrap;
    text-align: center;

    .washroom-icon {
      display: inline-block;
      height: 100%;
      margin-left: 1.2rem;
      position: relative;

      img {
        width: 4rem;

        &:first-child {
          margin-left: 0;
        }
      }

      .washroom-badge {
        width: 1.25em;
        height: 1.25em;
        position: absolute;
        top: 0;
        right: -0.2em;
        border-radius: 50%;
        background-color: @brand--primary-color;
        color: @light-text;

        span {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          font-size: 0.85em;
        }
      }
    }

    &.washrooms-count--large {
      .washroom-icon {
        margin-left: 2rem;

        &:first-child {
          margin-left: 0;
        }

        img {
          width: 5.5rem;
        }
      }

      .washroom-badge {
        width: 1.4em;
        height: 1.4em;
        line-height: 1.5em;
        font-size: 1em;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// WashroomsCount.vue?38aa337e